module.exports = __webpack_public_path__ + "static/logo300white-335ce7aebb80adbfa7ea83aea8671753.png";